// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import CrownOutlined from '/Users/bobqin/DEV2024-WINTER/salary/salary-admin-antd/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import AccountBookOutlined from '/Users/bobqin/DEV2024-WINTER/salary/salary-admin-antd/node_modules/@ant-design/icons/es/icons/AccountBookOutlined';
export default { CrownOutlined, AccountBookOutlined };
